<template>

	<footer>
		<div class="grass"></div>
		<div class="footer-mobile-sidebar"> </div>
	</footer>

</template>


<script>
	
	export default {
		name: 'grass-footer'
	}

</script>


<style lang="scss">

	footer {
		
		height: 0;
		margin: 0;

		.grass {
			position: fixed;
			z-index: 100;
			left: 0;
			bottom: 0;
			right: 0;
			height: calc((100vw / #{$grass-ratio}) - 4px);
			pointer-events: none;
			transform: scaleY(0.75) translateY(25%);

			@include mobile {
				// left: -5vw;
				// right: -5vw;
				bottom: 30px;
				height: calc((110vw / #{$grass-ratio}) + #{$footer-mobile-height} - 4px);
				transform: none;
			}

			&::after {
				display: block;
				width: $page-width;
				height: 100%;
				margin: 0 auto;
				max-width: $page-max-width;
				content: ' ';
				background-image: url(/img/grass.svg);
				background-size: 100vw calc(100vw / #{$grass-ratio});
				background-position: center;

				@include mobile {
					width: calc(100vw - 24px);
					background-image: url('/img/grass-mobile.svg');
					background-size: 110vw calc(110vw / #{$grass-ratio});
					background-position: center bottom;
					background-repeat: no-repeat;
				}
			}
		}

		.footer-mobile-sidebar {
			display: none;

			@include mobile {
				display: block;
				position: fixed;
				z-index: 99;
				left: $mobile-page-margin;
				right: $mobile-page-margin;
				bottom: 0;
				height: calc(#{$footer-mobile-height} + 1px);
				background-color: #5b9f37;
			}
		}
	}


</style>
